import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ContactLinkSection.css';
import ContactButton from '../../Common/ContactComponent/ContactButton';
import ContactComponent from '../../Common/ContactComponent/ContactComponent';
import { RainbowButton } from '../../ui/rainbow-button';
import contactIMG from '../../../assets/images/contact-img-bg.png';
import { contactLinkData } from '../../../data/contactLinkData';

interface ContactLinkSectionProps {
  title?: string;
  subtitle?: string;
  pageKey?: keyof typeof contactLinkData;
}

const ContactLinkSection: React.FC<ContactLinkSectionProps> = ({ 
  title, 
  subtitle,
  pageKey = 'home'
}) => {
  const { t, i18n } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    if (isContactModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isContactModalOpen]);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  const displayTitle = pageKey && contactLinkData[pageKey] 
    ? contactLinkData[pageKey].getTitle() 
    : title;
    
  const displaySubtitle = pageKey && contactLinkData[pageKey] 
    ? contactLinkData[pageKey].getSubtitle() 
    : subtitle;

  const getButtonText = () => {
    return i18n.language === 'en' ? 'Contact us' : 'Contactez-nous';
  };

  return (
    <div className="contact-link-section">
      <div className="background-overlay"></div>
      <div className="content-container">
        <h1 className="title">{displayTitle}</h1>
        <p className="subtitle-contact">{displaySubtitle}</p>
        <div className="buttons-container flex gap-4">
          <RainbowButton 
            onClick={handleOpenContactModal}
            className="tw-px-6 tw-py-3 tw-text-lg"
          >
            {getButtonText()}
          </RainbowButton>
        </div>
      </div>
  
      {isContactModalOpen && (
        <ContactComponent isOpen={true} onClose={handleCloseContactModal} />
      )}
    </div>
  );
};

export default ContactLinkSection;